import { Options } from 'vue-class-component';
import SceneWizardStep, { SceneWizardStepEnum } from '../SceneWizardStep';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import {
  ButtonTrigger,
  DateAndTimeTrigger,
  DeviceDTO,
  IObjectTrigger,
  ObjectTrigger,
  SceneObjectType,
  Trigger,
  TriggerDTO,
  TriggersAndConditionsRoomItemDTO,
} from '@/../client-generator/generated-clients/plants';
import ScenePanelDeviceButtons from '../ScenePanelDeviceButtons/ScenePanelDeviceButtons.vue';
import ScenePanelObjects from '../ScenePanelObjects/ScenePanelObjects.vue';
import ScenePanelTime from '../ScenePanelTime/ScenePanelTime.vue';
import SceneStepItemsList from '../SceneStepItemsList/SceneStepItemsList.vue';
import DialogAddTriggerAndCondition from '../DialogAddTriggerAndCondition/DialogAddTriggerAndCondition.vue';

@Options({
  name: 'SceneWizardStep3',
  components: {
    ScenePanelDeviceButtons,
    ScenePanelObjects,
    ScenePanelTime,
    SceneStepItemsList,
    DialogAddTriggerAndCondition,
  },
})
export default class SceneWizardStep3 extends SceneWizardStep {
  SlotRuleServiceType = SlotRuleServiceType;
  SceneWizardStepEnum = SceneWizardStepEnum;
  compatibleDevices: DeviceDTO[] = [];
  triggersRoomsList: TriggersAndConditionsRoomItemDTO[] = [];
  isVisibleDialogTrigger = false;
  tempTriggerDTOToEdit: TriggerDTO | null = null;
  tempTriggerToEdit: Trigger | null = null;

  mounted() {
    this.fetchTriggersList();
  }

  get currentDevicesCommands() {
    return [];
  }

  get triggerText() {
    if (this.scene?.triggers?.length == 1){
      return this.$t('scenes.trigger')
    }else{
      return this.$t('AppResource.Triggers')
    }
  }

  async fetchTriggersList() {
    try {
      this.$store.dispatch(SET_APP_LOADING, true);
      const response = await plantsClient.sceneTriggersList(
        this.plantId as number
      );

      this.compatibleDevices = response.compatibleDevices as DeviceDTO[];
      this.triggersRoomsList = response.triggersRoomsList as TriggersAndConditionsRoomItemDTO[];
    } catch (error) {
      let messageError = '';
      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleAddTrigger(
    trigger: ObjectTrigger | ButtonTrigger | DateAndTimeTrigger,
    objectName: string,
    sceneObjectType: SceneObjectType
  ) {
    //TODO: align with xamarin -> guid converted in int?!? -> max + 1?
    const idsArray = (this.scene.triggers?.flatMap(
      (x) => x.triggerParams?.id
    ) ?? []) as number[];
    const uniqueId = idsArray.length ? Math.max(...idsArray) + 1 : 1;
    trigger.id = uniqueId;

    this.scene.triggers?.push(
      new TriggerDTO({
        objectName: objectName,
        sceneObjectType: sceneObjectType,
        triggerParams: trigger,
      })
    );
  }

  handleEdit(trigger: TriggerDTO) {
    this.tempTriggerDTOToEdit = trigger;
    this.tempTriggerToEdit = new Trigger(trigger.triggerParams);
    this.isVisibleDialogTrigger = true;
  }

  handleRemove(trigger: TriggerDTO) {
    this.scene.triggers = this.scene.triggers?.filter(
      (x) => x.triggerParams?.id !== trigger.triggerParams?.id
    );
  }

  handleDoEditTrigger() {
    if (!this.tempTriggerToEdit || !this.tempTriggerDTOToEdit?.triggerParams)
      return;

    this.tempTriggerDTOToEdit.triggerParams = this.tempTriggerToEdit;
  }
}
